import React, { Component } from 'react';
import { displayURL } from '@features/utils/functions';
import Editable from '../Editable/Editable';
import ImageUploader from '../ImageUploader/ImageUploader';
import IV from '../InputValidation/InputValidation';
import IPersonComponent, { TPersonComponent } from './IPersonComponent';
import NoPhotoMaleBigImage from '@images/no_photo_male_big.png';

const isEqual = require('lodash.isequal');

import * as style from './PersonComponentStyle.module.scss'
import * as appStyle from '../../AppStyle.module.scss';



export default class PersonComponent extends Component<IPersonComponent, TPersonComponent> {

  state: TPersonComponent = {
    data: {
      imageId: null,
      name: this.props.name,
      role: this.props.role,
      linkedin_page: this.props.linkedin_page || '',
      editable: this.props.editable,
    },
    hideError: {
      name: true,
      role: true,
      linkedin_page: true,
    },
    editing: false,
    errors: {},
  };

  componentDidUpdate(prevProps: IPersonComponent, prevState: TPersonComponent) {
    if (!isEqual(prevState.data, this.state.data) && this.props.updateStateFromChild && this.props.index) {
      this.props.updateStateFromChild(this.props.index, this.state.data);
    }
  }

  renderComponent() {
    let component = this.viewComponent();
    if (this.props.editMode) {
      component = this.editComponent();
    }
    return component;
  }

  getImageId = (resp: { id: number; url: string }) => {
    this.setState({
      data: {
        ...this.state.data,
        imageId: resp.id,
      },
    });
  }

  toggleEditing = () => {
    this.setState({
      editing: !this.state.editing,
    });
  }

  onFocus = (name: string) => {
    this.setState({
      hideError: {
        ...this.state.hideError,
        [name]: false,
      },
    });
  }

  handleError = (name: string, err: boolean) => {
    if (this.state.errors[name] !== err) {
      this.setState({
        errors: {
          ...this.state.errors,
          [name]: err,
        },
      });
    }
  }

  editComponent() {
    const { index } = this.props;
    const editBtnClass = this.state.editing ? appStyle.editButtonActive : appStyle.editButton;
    const editContainerClass = this.state.editing ? style.edit : null;
    const disabledEdit = !Object.values(this.state.errors).every((elem: boolean) => (!elem));

    return (
      <div className={[style.person, style.personEdit, editContainerClass].join(' ')} id={this.props.id}>
        <div className={style.personImage}>
          {this.state.data.editable ?
            <ImageUploader
              getImageId={this.getImageId}
              type="avatar"
              avatar={this.props.avatar}
              uploadSizeLimit={5}
            /> :
            <div
              style={{ backgroundImage: `url(${this.props.avatar || NoPhotoMaleBigImage})` }}
              className={style.personAvatar}
            />
          }
          <div className={style.buttons}>
            {this.state.data.editable &&
              <button disabled={disabledEdit} className={editBtnClass} onClick={this.toggleEditing}/>
            }
            {!this.state.data.editable && !this.props.isInvestor ? null :
              <button
                className={appStyle.cancelButton}
                onClick={() => this.props.removePerson && this.props.removePerson(index)}
              />
            }
          </div>
        </div>
        <div className={[style.personDescription, style.personDescriptionEdit].join(' ')}>
          <span className={style.personName}>
            {this.state.editing ?
              <IV
                type="noEmpty"
                dispatch={this.props.dispatch}
                hide={this.state.hideError.name}
                handleError={{ name: 'name', fun: this.handleError }}
              >
                <Editable
                  type="input"
                  _this={this}
                  name="name"
                  onFocus={this.onFocus}
                  cl={style.personForEditable}
                  ph="Name"
                />
              </IV> :
              <div className={style.nameHolder}>
                {this.state.data.name ?
                  this.state.data.name :
                  <IV type="noEmpty" dispatch={this.props.dispatch} hide={this.state.hideError.name} value="">
                    Name
                  </IV>
                }
              </div>
            }
          </span>
          <span className={style.personPosition}>
            {this.state.editing ?
              <Editable
                type="input"
                _this={this}
                name="role"
                onFocus={this.onFocus}
                cl={style.personForEditable}
                ph="Role"
              /> :
              <p>{this.state.data.role}</p>
            }
            </span>
          {this.state.editing ?
            <IV
              type="UrlEmpty"
              dispatch={this.props.dispatch}
              hide={this.state.hideError.linkedin_page}
              handleError={{ name: 'url', fun: this.handleError }}
            >
              <Editable
                type="input"
                _this={this}
                name="linkedin_page"
                onFocus={this.onFocus}
                cl={style.personForEditable}
                ph="Linkedin"
              />
            </IV> :
            this.state.data.linkedin_page && (
              <span className={style.personSocial}>
                <span className="fa fa-linkedin"/>
              </span>
            )
          }
        </div>

      </div>
    );
  }

  viewComponent() {
    const { avatar, name, role, linkedin_page } = this.props;

    return (
      <div className={style.person}>
        <div className={style.personImage}>
          <div
            style={{ backgroundImage: `url(${avatar || NoPhotoMaleBigImage})` }}
            className={style.personAvatar}
          />
        </div>
        <div className={style.personDescription}>
          <span className={style.personName}>
            {name}
          </span>
          <span className={style.personPosition}>
            {role}
          </span>
          {
            linkedin_page &&
            <a
              href={displayURL(linkedin_page)}
              className={style.personSocial}
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className={['fa fa-linkedin', style.fa].join(' ')} />
            </a>
          }
        </div>
      </div>
    );
  }

  render() {
    return (
      this.renderComponent()
    );
  }
}
